export default "__VITE_ASSET__qbRuv99J__"